import { makeStyles, Theme } from '@material-ui/core/styles';

import { PHOTO_VALIDATION_COLORS } from '../PhotoValidationModal/photoValidationModalStyles';

export const usePhotoRequirementsDialogStyles = makeStyles((theme: Theme) => ({
  modal: {
    '& .hid-modal__container': {
      maxWidth: 640,
    },
  },
  paper: {
    borderRadius: 14,
    width: '100%',
    maxWidth: 640,
    margin: theme.spacing(2),
  },
  root: {
    padding: theme.spacing(3, 3, 2),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2, 2, 1.5),
    },
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
  },
  headerIconWrap: {
    width: 44,
    height: 44,
    borderRadius: '50%',
    backgroundColor: PHOTO_VALIDATION_COLORS.infoBg,
    border: `1px solid ${PHOTO_VALIDATION_COLORS.infoBorder}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  headerIcon: {
    color: PHOTO_VALIDATION_COLORS.info,
    fontSize: 24,
  },
  headerText: {
    flex: 1,
    minWidth: 0,
    paddingTop: theme.spacing(0.25),
  },
  title: {
    fontSize: 20,
    fontWeight: 600,
    color: theme.palette.text.primary,
    lineHeight: 1.3,
  },
  subtitle: {
    marginTop: theme.spacing(0.5),
    fontSize: 14,
    color: PHOTO_VALIDATION_COLORS.mutedText,
    lineHeight: 1.5,
  },
  closeButton: {
    marginTop: -theme.spacing(1),
    marginRight: -theme.spacing(1),
    color: PHOTO_VALIDATION_COLORS.mutedText,
  },
  content: {
    minHeight: 120,
  },
  loadingWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(6, 2),
  },
  errorWrap: {
    textAlign: 'center',
    padding: theme.spacing(4, 2),
  },
  errorTitle: {
    fontSize: 15,
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(0.5),
  },
  errorSubtitle: {
    fontSize: 14,
    color: PHOTO_VALIDATION_COLORS.mutedText,
    marginBottom: theme.spacing(2),
  },
  retryButton: {
    textTransform: 'none',
    fontWeight: 600,
  },
  requirementsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  requirementRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
  },
  checkIcon: {
    color: PHOTO_VALIDATION_COLORS.success,
    fontSize: 22,
    flexShrink: 0,
    marginTop: 2,
  },
  requirementIconWrap: {
    width: 36,
    height: 36,
    borderRadius: 8,
    backgroundColor: PHOTO_VALIDATION_COLORS.infoBg,
    border: `1px solid ${PHOTO_VALIDATION_COLORS.infoBorder}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  requirementIcon: {
    color: PHOTO_VALIDATION_COLORS.info,
    fontSize: 20,
  },
  requirementText: {
    flex: 1,
    minWidth: 0,
  },
  requirementTitle: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.text.primary,
    lineHeight: 1.4,
  },
  requirementDescription: {
    fontSize: 13,
    color: PHOTO_VALIDATION_COLORS.mutedText,
    marginTop: theme.spacing(0.25),
    lineHeight: 1.5,
  },
  colorSwatchRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginTop: theme.spacing(0.75),
    flexWrap: 'wrap',
  },
  colorSwatchLabel: {
    fontSize: 13,
    color: PHOTO_VALIDATION_COLORS.mutedText,
  },
  colorSwatch: {
    width: 28,
    height: 28,
    borderRadius: 6,
    flexShrink: 0,
    border: '1px solid rgba(0, 0, 0, 0.18)',
    boxShadow: 'inset 0 0 0 1px rgba(255, 255, 255, 0.35)',
  },
  colorSwatchName: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  infoBox: {
    marginTop: theme.spacing(2.5),
    display: 'flex',
    gap: theme.spacing(1),
    padding: theme.spacing(1.5),
    borderRadius: 10,
    backgroundColor: PHOTO_VALIDATION_COLORS.infoBg,
    border: `1px solid ${PHOTO_VALIDATION_COLORS.infoBorder}`,
  },
  infoIcon: {
    color: PHOTO_VALIDATION_COLORS.info,
    fontSize: 20,
    flexShrink: 0,
  },
  infoText: {
    fontSize: 13,
    color: PHOTO_VALIDATION_COLORS.mutedText,
    lineHeight: 1.6,
  },
  footer: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2, 3, 2.5),
    borderTop: `1px solid ${PHOTO_VALIDATION_COLORS.border}`,
  },
  okButton: {
    textTransform: 'none',
    fontWeight: 600,
    minWidth: 140,
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    '&:hover': { backgroundColor: theme.palette.primary.main },
  },
  helpLink: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    marginTop: theme.spacing(1),
    padding: 0,
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    font: 'inherit',
    fontSize: 14,
    color: theme.palette.primary.main,
    textDecoration: 'underline',
    '&:hover': {
      color: theme.palette.primary.dark,
    },
  },
  helpLinkIcon: {
    fontSize: 16,
  },
}));

export default usePhotoRequirementsDialogStyles;
